import { StyledContainer, StyledLightButton } from './FilesContent.styles'
import useUserFiles from 'hooks/user/useUserFiles'
import { FormTable } from 'components/FormTable'

const FilesContent = () => {
  const { filesColumns, filesDataSource, handleAddFile, displayDeleteButton, setSelectedRows, handleDeleteModal } = useUserFiles()

  return (
    <StyledContainer>
      <StyledLightButton onClick={handleAddFile}>Upload File</StyledLightButton>
      <FormTable
        columns={filesColumns}
        dataSource={filesDataSource}
        setSelectedRows={setSelectedRows}
        displayDeleteButton={displayDeleteButton}
        handleDeleteModal={handleDeleteModal}
        spacesAroundGrid={false}
        tableContainerBgColor="#fefefe"
      />
    </StyledContainer>
  )
}

export default FilesContent
